import { createReducer, on } from '@ngrx/store';
import { setIsCustomSecurity } from './is-custom-security.actions';
export const isCustomSecurity = createReducer(false, on(setIsCustomSecurity, (state, action) => {
    return action.isCustomSecurity;
}));
